export default __webpack_public_path__ + "static/media/5.110ebab8.png";